import React, { ReactNode } from "react";

import { useIntl } from "react-intl";

import BottomNavigationBar from "@app/component/BottomNavigationBar";
interface Props {
  nextButtonConfirmationCancelText?: string;
  nextButtonConfirmationMessage?: ReactNode;
  nextButtonConfirmationOkText?: string;
  nextButtonErrorMessage?: string;
  nextDisabled: boolean;
  onConfirmationCancel?: () => void;
  onConfirmationOk?: () => void;
  onNextClick: () => void;
  onPreviousClick: () => void;
  previousHidden: boolean;
}

const ButtonBar: React.FC<Props> = ({
  nextButtonConfirmationCancelText,
  nextButtonConfirmationMessage,
  nextButtonConfirmationOkText,
  nextButtonErrorMessage,
  nextDisabled,
  onConfirmationCancel,
  onConfirmationOk,
  onNextClick,
  onPreviousClick,
  previousHidden,
}) => {
  const intl = useIntl();

  return (
    <BottomNavigationBar
      nextButtonConfirmationCancelText={nextButtonConfirmationCancelText}
      nextButtonConfirmationMessage={nextButtonConfirmationMessage}
      nextButtonConfirmationOkText={nextButtonConfirmationOkText}
      nextButtonErrorMessage={nextButtonErrorMessage}
      nextButtonTitle={intl.formatMessage({
        id: "settings.newImports.buttonBar.nextButtonTitle",
        defaultMessage: "Continue to next step",
        description: "Text of next button",
      })}
      nextDisabled={nextDisabled}
      onConfirmationCancel={onConfirmationCancel}
      onConfirmationOk={onConfirmationOk}
      onNextClick={onNextClick}
      onPreviousClick={onPreviousClick}
      previousHidden={previousHidden}
    />
  );
};

export default ButtonBar;
